import { defineComponent as Ve, ref as B, onMounted as _t, openBlock as A, createElementBlock as P, Fragment as pe, createVNode as D, unref as b, withCtx as M, createTextVNode as v, toDisplayString as H, createElementVNode as U, renderList as $e, normalizeStyle as Rt, computed as Tt, onBeforeMount as Ot, normalizeClass as Pe, createBlock as ae, createCommentVNode as Q } from "vue";
import { MpText as C, MpRadio as yt, MpButton as W, MpIcon as At } from "@borg/ui";
function ze(e, t) {
  return function() {
    return e.apply(t, arguments);
  };
}
const { toString: bt } = Object.prototype, { getPrototypeOf: Te } = Object, ne = ((e) => (t) => {
  const n = bt.call(t);
  return e[n] || (e[n] = n.slice(8, -1).toLowerCase());
})(/* @__PURE__ */ Object.create(null)), I = (e) => (e = e.toLowerCase(), (t) => ne(t) === e), re = (e) => (t) => typeof t === e, { isArray: j } = Array, z = re("undefined");
function Nt(e) {
  return e !== null && !z(e) && e.constructor !== null && !z(e.constructor) && N(e.constructor.isBuffer) && e.constructor.isBuffer(e);
}
const Ge = I("ArrayBuffer");
function wt(e) {
  let t;
  return typeof ArrayBuffer < "u" && ArrayBuffer.isView ? t = ArrayBuffer.isView(e) : t = e && e.buffer && Ge(e.buffer), t;
}
const gt = re("string"), N = re("function"), Qe = re("number"), oe = (e) => e !== null && typeof e == "object", It = (e) => e === !0 || e === !1, J = (e) => {
  if (ne(e) !== "object")
    return !1;
  const t = Te(e);
  return (t === null || t === Object.prototype || Object.getPrototypeOf(t) === null) && !(Symbol.toStringTag in e) && !(Symbol.iterator in e);
}, Pt = I("Date"), Dt = I("File"), St = I("Blob"), Ut = I("FileList"), Lt = (e) => oe(e) && N(e.pipe), xt = (e) => {
  let t;
  return e && (typeof FormData == "function" && e instanceof FormData || N(e.append) && ((t = ne(e)) === "formdata" || // detect form-data instance
  t === "object" && N(e.toString) && e.toString() === "[object FormData]"));
}, Ft = I("URLSearchParams"), [kt, Bt, Mt, vt] = ["ReadableStream", "Request", "Response", "Headers"].map(I), Ht = (e) => e.trim ? e.trim() : e.replace(/^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g, "");
function G(e, t, { allOwnKeys: n = !1 } = {}) {
  if (e === null || typeof e > "u")
    return;
  let r, o;
  if (typeof e != "object" && (e = [e]), j(e))
    for (r = 0, o = e.length; r < o; r++)
      t.call(null, e[r], r, e);
  else {
    const i = n ? Object.getOwnPropertyNames(e) : Object.keys(e), s = i.length;
    let l;
    for (r = 0; r < s; r++)
      l = i[r], t.call(null, e[l], l, e);
  }
}
function We(e, t) {
  t = t.toLowerCase();
  const n = Object.keys(e);
  let r = n.length, o;
  for (; r-- > 0; )
    if (o = n[r], t === o.toLowerCase())
      return o;
  return null;
}
const Je = (() => typeof globalThis < "u" ? globalThis : typeof self < "u" ? self : typeof window < "u" ? window : global)(), Ke = (e) => !z(e) && e !== Je;
function de() {
  const { caseless: e } = Ke(this) && this || {}, t = {}, n = (r, o) => {
    const i = e && We(t, o) || o;
    J(t[i]) && J(r) ? t[i] = de(t[i], r) : J(r) ? t[i] = de({}, r) : j(r) ? t[i] = r.slice() : t[i] = r;
  };
  for (let r = 0, o = arguments.length; r < o; r++)
    arguments[r] && G(arguments[r], n);
  return t;
}
const Ct = (e, t, n, { allOwnKeys: r } = {}) => (G(t, (o, i) => {
  n && N(o) ? e[i] = ze(o, n) : e[i] = o;
}, { allOwnKeys: r }), e), jt = (e) => (e.charCodeAt(0) === 65279 && (e = e.slice(1)), e), qt = (e, t, n, r) => {
  e.prototype = Object.create(t.prototype, r), e.prototype.constructor = e, Object.defineProperty(e, "super", {
    value: t.prototype
  }), n && Object.assign(e.prototype, n);
}, Vt = (e, t, n, r) => {
  let o, i, s;
  const l = {};
  if (t = t || {}, e == null)
    return t;
  do {
    for (o = Object.getOwnPropertyNames(e), i = o.length; i-- > 0; )
      s = o[i], (!r || r(s, e, t)) && !l[s] && (t[s] = e[s], l[s] = !0);
    e = n !== !1 && Te(e);
  } while (e && (!n || n(e, t)) && e !== Object.prototype);
  return t;
}, $t = (e, t, n) => {
  e = String(e), (n === void 0 || n > e.length) && (n = e.length), n -= t.length;
  const r = e.indexOf(t, n);
  return r !== -1 && r === n;
}, zt = (e) => {
  if (!e)
    return null;
  if (j(e))
    return e;
  let t = e.length;
  if (!Qe(t))
    return null;
  const n = new Array(t);
  for (; t-- > 0; )
    n[t] = e[t];
  return n;
}, Gt = ((e) => (t) => e && t instanceof e)(typeof Uint8Array < "u" && Te(Uint8Array)), Qt = (e, t) => {
  const r = (e && e[Symbol.iterator]).call(e);
  let o;
  for (; (o = r.next()) && !o.done; ) {
    const i = o.value;
    t.call(e, i[0], i[1]);
  }
}, Wt = (e, t) => {
  let n;
  const r = [];
  for (; (n = e.exec(t)) !== null; )
    r.push(n);
  return r;
}, Jt = I("HTMLFormElement"), Kt = (e) => e.toLowerCase().replace(
  /[-_\s]([a-z\d])(\w*)/g,
  function(n, r, o) {
    return r.toUpperCase() + o;
  }
), De = (({ hasOwnProperty: e }) => (t, n) => e.call(t, n))(Object.prototype), Yt = I("RegExp"), Ye = (e, t) => {
  const n = Object.getOwnPropertyDescriptors(e), r = {};
  G(n, (o, i) => {
    let s;
    (s = t(o, i, e)) !== !1 && (r[i] = s || o);
  }), Object.defineProperties(e, r);
}, Xt = (e) => {
  Ye(e, (t, n) => {
    if (N(e) && ["arguments", "caller", "callee"].indexOf(n) !== -1)
      return !1;
    const r = e[n];
    if (N(r)) {
      if (t.enumerable = !1, "writable" in t) {
        t.writable = !1;
        return;
      }
      t.set || (t.set = () => {
        throw Error("Can not rewrite read-only method '" + n + "'");
      });
    }
  });
}, Zt = (e, t) => {
  const n = {}, r = (o) => {
    o.forEach((i) => {
      n[i] = !0;
    });
  };
  return j(e) ? r(e) : r(String(e).split(t)), n;
}, en = () => {
}, tn = (e, t) => e != null && Number.isFinite(e = +e) ? e : t, ce = "abcdefghijklmnopqrstuvwxyz", Se = "0123456789", Xe = {
  DIGIT: Se,
  ALPHA: ce,
  ALPHA_DIGIT: ce + ce.toUpperCase() + Se
}, nn = (e = 16, t = Xe.ALPHA_DIGIT) => {
  let n = "";
  const { length: r } = t;
  for (; e--; )
    n += t[Math.random() * r | 0];
  return n;
};
function rn(e) {
  return !!(e && N(e.append) && e[Symbol.toStringTag] === "FormData" && e[Symbol.iterator]);
}
const on = (e) => {
  const t = new Array(10), n = (r, o) => {
    if (oe(r)) {
      if (t.indexOf(r) >= 0)
        return;
      if (!("toJSON" in r)) {
        t[o] = r;
        const i = j(r) ? [] : {};
        return G(r, (s, l) => {
          const f = n(s, o + 1);
          !z(f) && (i[l] = f);
        }), t[o] = void 0, i;
      }
    }
    return r;
  };
  return n(e, 0);
}, sn = I("AsyncFunction"), an = (e) => e && (oe(e) || N(e)) && N(e.then) && N(e.catch), a = {
  isArray: j,
  isArrayBuffer: Ge,
  isBuffer: Nt,
  isFormData: xt,
  isArrayBufferView: wt,
  isString: gt,
  isNumber: Qe,
  isBoolean: It,
  isObject: oe,
  isPlainObject: J,
  isReadableStream: kt,
  isRequest: Bt,
  isResponse: Mt,
  isHeaders: vt,
  isUndefined: z,
  isDate: Pt,
  isFile: Dt,
  isBlob: St,
  isRegExp: Yt,
  isFunction: N,
  isStream: Lt,
  isURLSearchParams: Ft,
  isTypedArray: Gt,
  isFileList: Ut,
  forEach: G,
  merge: de,
  extend: Ct,
  trim: Ht,
  stripBOM: jt,
  inherits: qt,
  toFlatObject: Vt,
  kindOf: ne,
  kindOfTest: I,
  endsWith: $t,
  toArray: zt,
  forEachEntry: Qt,
  matchAll: Wt,
  isHTMLForm: Jt,
  hasOwnProperty: De,
  hasOwnProp: De,
  // an alias to avoid ESLint no-prototype-builtins detection
  reduceDescriptors: Ye,
  freezeMethods: Xt,
  toObjectSet: Zt,
  toCamelCase: Kt,
  noop: en,
  toFiniteNumber: tn,
  findKey: We,
  global: Je,
  isContextDefined: Ke,
  ALPHABET: Xe,
  generateString: nn,
  isSpecCompliantForm: rn,
  toJSONObject: on,
  isAsyncFn: sn,
  isThenable: an
};
function E(e, t, n, r, o) {
  Error.call(this), Error.captureStackTrace ? Error.captureStackTrace(this, this.constructor) : this.stack = new Error().stack, this.message = e, this.name = "AxiosError", t && (this.code = t), n && (this.config = n), r && (this.request = r), o && (this.response = o);
}
a.inherits(E, Error, {
  toJSON: function() {
    return {
      // Standard
      message: this.message,
      name: this.name,
      // Microsoft
      description: this.description,
      number: this.number,
      // Mozilla
      fileName: this.fileName,
      lineNumber: this.lineNumber,
      columnNumber: this.columnNumber,
      stack: this.stack,
      // Axios
      config: a.toJSONObject(this.config),
      code: this.code,
      status: this.response && this.response.status ? this.response.status : null
    };
  }
});
const Ze = E.prototype, et = {};
[
  "ERR_BAD_OPTION_VALUE",
  "ERR_BAD_OPTION",
  "ECONNABORTED",
  "ETIMEDOUT",
  "ERR_NETWORK",
  "ERR_FR_TOO_MANY_REDIRECTS",
  "ERR_DEPRECATED",
  "ERR_BAD_RESPONSE",
  "ERR_BAD_REQUEST",
  "ERR_CANCELED",
  "ERR_NOT_SUPPORT",
  "ERR_INVALID_URL"
  // eslint-disable-next-line func-names
].forEach((e) => {
  et[e] = { value: e };
});
Object.defineProperties(E, et);
Object.defineProperty(Ze, "isAxiosError", { value: !0 });
E.from = (e, t, n, r, o, i) => {
  const s = Object.create(Ze);
  return a.toFlatObject(e, s, function(f) {
    return f !== Error.prototype;
  }, (l) => l !== "isAxiosError"), E.call(s, e.message, t, n, r, o), s.cause = e, s.name = e.name, i && Object.assign(s, i), s;
};
const cn = null;
function Ee(e) {
  return a.isPlainObject(e) || a.isArray(e);
}
function tt(e) {
  return a.endsWith(e, "[]") ? e.slice(0, -2) : e;
}
function Ue(e, t, n) {
  return e ? e.concat(t).map(function(o, i) {
    return o = tt(o), !n && i ? "[" + o + "]" : o;
  }).join(n ? "." : "") : t;
}
function ln(e) {
  return a.isArray(e) && !e.some(Ee);
}
const un = a.toFlatObject(a, {}, null, function(t) {
  return /^is[A-Z]/.test(t);
});
function se(e, t, n) {
  if (!a.isObject(e))
    throw new TypeError("target must be an object");
  t = t || new FormData(), n = a.toFlatObject(n, {
    metaTokens: !0,
    dots: !1,
    indexes: !1
  }, !1, function(h, O) {
    return !a.isUndefined(O[h]);
  });
  const r = n.metaTokens, o = n.visitor || c, i = n.dots, s = n.indexes, f = (n.Blob || typeof Blob < "u" && Blob) && a.isSpecCompliantForm(t);
  if (!a.isFunction(o))
    throw new TypeError("visitor must be a function");
  function u(d) {
    if (d === null)
      return "";
    if (a.isDate(d))
      return d.toISOString();
    if (!f && a.isBlob(d))
      throw new E("Blob is not supported. Use a Buffer instead.");
    return a.isArrayBuffer(d) || a.isTypedArray(d) ? f && typeof Blob == "function" ? new Blob([d]) : Buffer.from(d) : d;
  }
  function c(d, h, O) {
    let y = d;
    if (d && !O && typeof d == "object") {
      if (a.endsWith(h, "{}"))
        h = r ? h : h.slice(0, -2), d = JSON.stringify(d);
      else if (a.isArray(d) && ln(d) || (a.isFileList(d) || a.endsWith(h, "[]")) && (y = a.toArray(d)))
        return h = tt(h), y.forEach(function(R, V) {
          !(a.isUndefined(R) || R === null) && t.append(
            // eslint-disable-next-line no-nested-ternary
            s === !0 ? Ue([h], V, i) : s === null ? h : h + "[]",
            u(R)
          );
        }), !1;
    }
    return Ee(d) ? !0 : (t.append(Ue(O, h, i), u(d)), !1);
  }
  const p = [], _ = Object.assign(un, {
    defaultVisitor: c,
    convertValue: u,
    isVisitable: Ee
  });
  function m(d, h) {
    if (!a.isUndefined(d)) {
      if (p.indexOf(d) !== -1)
        throw Error("Circular reference detected in " + h.join("."));
      p.push(d), a.forEach(d, function(y, S) {
        (!(a.isUndefined(y) || y === null) && o.call(
          t,
          y,
          a.isString(S) ? S.trim() : S,
          h,
          _
        )) === !0 && m(y, h ? h.concat(S) : [S]);
      }), p.pop();
    }
  }
  if (!a.isObject(e))
    throw new TypeError("data must be an object");
  return m(e), t;
}
function Le(e) {
  const t = {
    "!": "%21",
    "'": "%27",
    "(": "%28",
    ")": "%29",
    "~": "%7E",
    "%20": "+",
    "%00": "\0"
  };
  return encodeURIComponent(e).replace(/[!'()~]|%20|%00/g, function(r) {
    return t[r];
  });
}
function Oe(e, t) {
  this._pairs = [], e && se(e, this, t);
}
const nt = Oe.prototype;
nt.append = function(t, n) {
  this._pairs.push([t, n]);
};
nt.toString = function(t) {
  const n = t ? function(r) {
    return t.call(this, r, Le);
  } : Le;
  return this._pairs.map(function(o) {
    return n(o[0]) + "=" + n(o[1]);
  }, "").join("&");
};
function fn(e) {
  return encodeURIComponent(e).replace(/%3A/gi, ":").replace(/%24/g, "$").replace(/%2C/gi, ",").replace(/%20/g, "+").replace(/%5B/gi, "[").replace(/%5D/gi, "]");
}
function rt(e, t, n) {
  if (!t)
    return e;
  const r = n && n.encode || fn, o = n && n.serialize;
  let i;
  if (o ? i = o(t, n) : i = a.isURLSearchParams(t) ? t.toString() : new Oe(t, n).toString(r), i) {
    const s = e.indexOf("#");
    s !== -1 && (e = e.slice(0, s)), e += (e.indexOf("?") === -1 ? "?" : "&") + i;
  }
  return e;
}
class pn {
  constructor() {
    this.handlers = [];
  }
  /**
   * Add a new interceptor to the stack
   *
   * @param {Function} fulfilled The function to handle `then` for a `Promise`
   * @param {Function} rejected The function to handle `reject` for a `Promise`
   *
   * @return {Number} An ID used to remove interceptor later
   */
  use(t, n, r) {
    return this.handlers.push({
      fulfilled: t,
      rejected: n,
      synchronous: r ? r.synchronous : !1,
      runWhen: r ? r.runWhen : null
    }), this.handlers.length - 1;
  }
  /**
   * Remove an interceptor from the stack
   *
   * @param {Number} id The ID that was returned by `use`
   *
   * @returns {Boolean} `true` if the interceptor was removed, `false` otherwise
   */
  eject(t) {
    this.handlers[t] && (this.handlers[t] = null);
  }
  /**
   * Clear all interceptors from the stack
   *
   * @returns {void}
   */
  clear() {
    this.handlers && (this.handlers = []);
  }
  /**
   * Iterate over all the registered interceptors
   *
   * This method is particularly useful for skipping over any
   * interceptors that may have become `null` calling `eject`.
   *
   * @param {Function} fn The function to call for each interceptor
   *
   * @returns {void}
   */
  forEach(t) {
    a.forEach(this.handlers, function(r) {
      r !== null && t(r);
    });
  }
}
const xe = pn, ot = {
  silentJSONParsing: !0,
  forcedJSONParsing: !0,
  clarifyTimeoutError: !1
}, dn = typeof URLSearchParams < "u" ? URLSearchParams : Oe, En = typeof FormData < "u" ? FormData : null, hn = typeof Blob < "u" ? Blob : null, mn = {
  isBrowser: !0,
  classes: {
    URLSearchParams: dn,
    FormData: En,
    Blob: hn
  },
  protocols: ["http", "https", "file", "blob", "url", "data"]
}, ye = typeof window < "u" && typeof document < "u", _n = ((e) => ye && ["ReactNative", "NativeScript", "NS"].indexOf(e) < 0)(typeof navigator < "u" && navigator.product), Rn = (() => typeof WorkerGlobalScope < "u" && // eslint-disable-next-line no-undef
self instanceof WorkerGlobalScope && typeof self.importScripts == "function")(), Tn = ye && window.location.href || "http://localhost", On = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  hasBrowserEnv: ye,
  hasStandardBrowserEnv: _n,
  hasStandardBrowserWebWorkerEnv: Rn,
  origin: Tn
}, Symbol.toStringTag, { value: "Module" })), w = {
  ...On,
  ...mn
};
function yn(e, t) {
  return se(e, new w.classes.URLSearchParams(), Object.assign({
    visitor: function(n, r, o, i) {
      return w.isNode && a.isBuffer(n) ? (this.append(r, n.toString("base64")), !1) : i.defaultVisitor.apply(this, arguments);
    }
  }, t));
}
function An(e) {
  return a.matchAll(/\w+|\[(\w*)]/g, e).map((t) => t[0] === "[]" ? "" : t[1] || t[0]);
}
function bn(e) {
  const t = {}, n = Object.keys(e);
  let r;
  const o = n.length;
  let i;
  for (r = 0; r < o; r++)
    i = n[r], t[i] = e[i];
  return t;
}
function st(e) {
  function t(n, r, o, i) {
    let s = n[i++];
    if (s === "__proto__")
      return !0;
    const l = Number.isFinite(+s), f = i >= n.length;
    return s = !s && a.isArray(o) ? o.length : s, f ? (a.hasOwnProp(o, s) ? o[s] = [o[s], r] : o[s] = r, !l) : ((!o[s] || !a.isObject(o[s])) && (o[s] = []), t(n, r, o[s], i) && a.isArray(o[s]) && (o[s] = bn(o[s])), !l);
  }
  if (a.isFormData(e) && a.isFunction(e.entries)) {
    const n = {};
    return a.forEachEntry(e, (r, o) => {
      t(An(r), o, n, 0);
    }), n;
  }
  return null;
}
function Nn(e, t, n) {
  if (a.isString(e))
    try {
      return (t || JSON.parse)(e), a.trim(e);
    } catch (r) {
      if (r.name !== "SyntaxError")
        throw r;
    }
  return (n || JSON.stringify)(e);
}
const Ae = {
  transitional: ot,
  adapter: ["xhr", "http", "fetch"],
  transformRequest: [function(t, n) {
    const r = n.getContentType() || "", o = r.indexOf("application/json") > -1, i = a.isObject(t);
    if (i && a.isHTMLForm(t) && (t = new FormData(t)), a.isFormData(t))
      return o ? JSON.stringify(st(t)) : t;
    if (a.isArrayBuffer(t) || a.isBuffer(t) || a.isStream(t) || a.isFile(t) || a.isBlob(t) || a.isReadableStream(t))
      return t;
    if (a.isArrayBufferView(t))
      return t.buffer;
    if (a.isURLSearchParams(t))
      return n.setContentType("application/x-www-form-urlencoded;charset=utf-8", !1), t.toString();
    let l;
    if (i) {
      if (r.indexOf("application/x-www-form-urlencoded") > -1)
        return yn(t, this.formSerializer).toString();
      if ((l = a.isFileList(t)) || r.indexOf("multipart/form-data") > -1) {
        const f = this.env && this.env.FormData;
        return se(
          l ? { "files[]": t } : t,
          f && new f(),
          this.formSerializer
        );
      }
    }
    return i || o ? (n.setContentType("application/json", !1), Nn(t)) : t;
  }],
  transformResponse: [function(t) {
    const n = this.transitional || Ae.transitional, r = n && n.forcedJSONParsing, o = this.responseType === "json";
    if (a.isResponse(t) || a.isReadableStream(t))
      return t;
    if (t && a.isString(t) && (r && !this.responseType || o)) {
      const s = !(n && n.silentJSONParsing) && o;
      try {
        return JSON.parse(t);
      } catch (l) {
        if (s)
          throw l.name === "SyntaxError" ? E.from(l, E.ERR_BAD_RESPONSE, this, null, this.response) : l;
      }
    }
    return t;
  }],
  /**
   * A timeout in milliseconds to abort a request. If set to 0 (default) a
   * timeout is not created.
   */
  timeout: 0,
  xsrfCookieName: "XSRF-TOKEN",
  xsrfHeaderName: "X-XSRF-TOKEN",
  maxContentLength: -1,
  maxBodyLength: -1,
  env: {
    FormData: w.classes.FormData,
    Blob: w.classes.Blob
  },
  validateStatus: function(t) {
    return t >= 200 && t < 300;
  },
  headers: {
    common: {
      Accept: "application/json, text/plain, */*",
      "Content-Type": void 0
    }
  }
};
a.forEach(["delete", "get", "head", "post", "put", "patch"], (e) => {
  Ae.headers[e] = {};
});
const be = Ae, wn = a.toObjectSet([
  "age",
  "authorization",
  "content-length",
  "content-type",
  "etag",
  "expires",
  "from",
  "host",
  "if-modified-since",
  "if-unmodified-since",
  "last-modified",
  "location",
  "max-forwards",
  "proxy-authorization",
  "referer",
  "retry-after",
  "user-agent"
]), gn = (e) => {
  const t = {};
  let n, r, o;
  return e && e.split(`
`).forEach(function(s) {
    o = s.indexOf(":"), n = s.substring(0, o).trim().toLowerCase(), r = s.substring(o + 1).trim(), !(!n || t[n] && wn[n]) && (n === "set-cookie" ? t[n] ? t[n].push(r) : t[n] = [r] : t[n] = t[n] ? t[n] + ", " + r : r);
  }), t;
}, Fe = Symbol("internals");
function $(e) {
  return e && String(e).trim().toLowerCase();
}
function K(e) {
  return e === !1 || e == null ? e : a.isArray(e) ? e.map(K) : String(e);
}
function In(e) {
  const t = /* @__PURE__ */ Object.create(null), n = /([^\s,;=]+)\s*(?:=\s*([^,;]+))?/g;
  let r;
  for (; r = n.exec(e); )
    t[r[1]] = r[2];
  return t;
}
const Pn = (e) => /^[-_a-zA-Z0-9^`|~,!#$%&'*+.]+$/.test(e.trim());
function le(e, t, n, r, o) {
  if (a.isFunction(r))
    return r.call(this, t, n);
  if (o && (t = n), !!a.isString(t)) {
    if (a.isString(r))
      return t.indexOf(r) !== -1;
    if (a.isRegExp(r))
      return r.test(t);
  }
}
function Dn(e) {
  return e.trim().toLowerCase().replace(/([a-z\d])(\w*)/g, (t, n, r) => n.toUpperCase() + r);
}
function Sn(e, t) {
  const n = a.toCamelCase(" " + t);
  ["get", "set", "has"].forEach((r) => {
    Object.defineProperty(e, r + n, {
      value: function(o, i, s) {
        return this[r].call(this, t, o, i, s);
      },
      configurable: !0
    });
  });
}
class ie {
  constructor(t) {
    t && this.set(t);
  }
  set(t, n, r) {
    const o = this;
    function i(l, f, u) {
      const c = $(f);
      if (!c)
        throw new Error("header name must be a non-empty string");
      const p = a.findKey(o, c);
      (!p || o[p] === void 0 || u === !0 || u === void 0 && o[p] !== !1) && (o[p || f] = K(l));
    }
    const s = (l, f) => a.forEach(l, (u, c) => i(u, c, f));
    if (a.isPlainObject(t) || t instanceof this.constructor)
      s(t, n);
    else if (a.isString(t) && (t = t.trim()) && !Pn(t))
      s(gn(t), n);
    else if (a.isHeaders(t))
      for (const [l, f] of t.entries())
        i(f, l, r);
    else
      t != null && i(n, t, r);
    return this;
  }
  get(t, n) {
    if (t = $(t), t) {
      const r = a.findKey(this, t);
      if (r) {
        const o = this[r];
        if (!n)
          return o;
        if (n === !0)
          return In(o);
        if (a.isFunction(n))
          return n.call(this, o, r);
        if (a.isRegExp(n))
          return n.exec(o);
        throw new TypeError("parser must be boolean|regexp|function");
      }
    }
  }
  has(t, n) {
    if (t = $(t), t) {
      const r = a.findKey(this, t);
      return !!(r && this[r] !== void 0 && (!n || le(this, this[r], r, n)));
    }
    return !1;
  }
  delete(t, n) {
    const r = this;
    let o = !1;
    function i(s) {
      if (s = $(s), s) {
        const l = a.findKey(r, s);
        l && (!n || le(r, r[l], l, n)) && (delete r[l], o = !0);
      }
    }
    return a.isArray(t) ? t.forEach(i) : i(t), o;
  }
  clear(t) {
    const n = Object.keys(this);
    let r = n.length, o = !1;
    for (; r--; ) {
      const i = n[r];
      (!t || le(this, this[i], i, t, !0)) && (delete this[i], o = !0);
    }
    return o;
  }
  normalize(t) {
    const n = this, r = {};
    return a.forEach(this, (o, i) => {
      const s = a.findKey(r, i);
      if (s) {
        n[s] = K(o), delete n[i];
        return;
      }
      const l = t ? Dn(i) : String(i).trim();
      l !== i && delete n[i], n[l] = K(o), r[l] = !0;
    }), this;
  }
  concat(...t) {
    return this.constructor.concat(this, ...t);
  }
  toJSON(t) {
    const n = /* @__PURE__ */ Object.create(null);
    return a.forEach(this, (r, o) => {
      r != null && r !== !1 && (n[o] = t && a.isArray(r) ? r.join(", ") : r);
    }), n;
  }
  [Symbol.iterator]() {
    return Object.entries(this.toJSON())[Symbol.iterator]();
  }
  toString() {
    return Object.entries(this.toJSON()).map(([t, n]) => t + ": " + n).join(`
`);
  }
  get [Symbol.toStringTag]() {
    return "AxiosHeaders";
  }
  static from(t) {
    return t instanceof this ? t : new this(t);
  }
  static concat(t, ...n) {
    const r = new this(t);
    return n.forEach((o) => r.set(o)), r;
  }
  static accessor(t) {
    const r = (this[Fe] = this[Fe] = {
      accessors: {}
    }).accessors, o = this.prototype;
    function i(s) {
      const l = $(s);
      r[l] || (Sn(o, s), r[l] = !0);
    }
    return a.isArray(t) ? t.forEach(i) : i(t), this;
  }
}
ie.accessor(["Content-Type", "Content-Length", "Accept", "Accept-Encoding", "User-Agent", "Authorization"]);
a.reduceDescriptors(ie.prototype, ({ value: e }, t) => {
  let n = t[0].toUpperCase() + t.slice(1);
  return {
    get: () => e,
    set(r) {
      this[n] = r;
    }
  };
});
a.freezeMethods(ie);
const g = ie;
function ue(e, t) {
  const n = this || be, r = t || n, o = g.from(r.headers);
  let i = r.data;
  return a.forEach(e, function(l) {
    i = l.call(n, i, o.normalize(), t ? t.status : void 0);
  }), o.normalize(), i;
}
function it(e) {
  return !!(e && e.__CANCEL__);
}
function q(e, t, n) {
  E.call(this, e ?? "canceled", E.ERR_CANCELED, t, n), this.name = "CanceledError";
}
a.inherits(q, E, {
  __CANCEL__: !0
});
function at(e, t, n) {
  const r = n.config.validateStatus;
  !n.status || !r || r(n.status) ? e(n) : t(new E(
    "Request failed with status code " + n.status,
    [E.ERR_BAD_REQUEST, E.ERR_BAD_RESPONSE][Math.floor(n.status / 100) - 4],
    n.config,
    n.request,
    n
  ));
}
function Un(e) {
  const t = /^([-+\w]{1,25})(:?\/\/|:)/.exec(e);
  return t && t[1] || "";
}
function Ln(e, t) {
  e = e || 10;
  const n = new Array(e), r = new Array(e);
  let o = 0, i = 0, s;
  return t = t !== void 0 ? t : 1e3, function(f) {
    const u = Date.now(), c = r[i];
    s || (s = u), n[o] = f, r[o] = u;
    let p = i, _ = 0;
    for (; p !== o; )
      _ += n[p++], p = p % e;
    if (o = (o + 1) % e, o === i && (i = (i + 1) % e), u - s < t)
      return;
    const m = c && u - c;
    return m ? Math.round(_ * 1e3 / m) : void 0;
  };
}
function xn(e, t) {
  let n = 0;
  const r = 1e3 / t;
  let o = null;
  return function() {
    const s = this === !0, l = Date.now();
    if (s || l - n > r)
      return o && (clearTimeout(o), o = null), n = l, e.apply(null, arguments);
    o || (o = setTimeout(() => (o = null, n = Date.now(), e.apply(null, arguments)), r - (l - n)));
  };
}
const X = (e, t, n = 3) => {
  let r = 0;
  const o = Ln(50, 250);
  return xn((i) => {
    const s = i.loaded, l = i.lengthComputable ? i.total : void 0, f = s - r, u = o(f), c = s <= l;
    r = s;
    const p = {
      loaded: s,
      total: l,
      progress: l ? s / l : void 0,
      bytes: f,
      rate: u || void 0,
      estimated: u && l && c ? (l - s) / u : void 0,
      event: i,
      lengthComputable: l != null
    };
    p[t ? "download" : "upload"] = !0, e(p);
  }, n);
}, Fn = w.hasStandardBrowserEnv ? (
  // Standard browser envs have full support of the APIs needed to test
  // whether the request URL is of the same origin as current location.
  function() {
    const t = /(msie|trident)/i.test(navigator.userAgent), n = document.createElement("a");
    let r;
    function o(i) {
      let s = i;
      return t && (n.setAttribute("href", s), s = n.href), n.setAttribute("href", s), {
        href: n.href,
        protocol: n.protocol ? n.protocol.replace(/:$/, "") : "",
        host: n.host,
        search: n.search ? n.search.replace(/^\?/, "") : "",
        hash: n.hash ? n.hash.replace(/^#/, "") : "",
        hostname: n.hostname,
        port: n.port,
        pathname: n.pathname.charAt(0) === "/" ? n.pathname : "/" + n.pathname
      };
    }
    return r = o(window.location.href), function(s) {
      const l = a.isString(s) ? o(s) : s;
      return l.protocol === r.protocol && l.host === r.host;
    };
  }()
) : (
  // Non standard browser envs (web workers, react-native) lack needed support.
  function() {
    return function() {
      return !0;
    };
  }()
), kn = w.hasStandardBrowserEnv ? (
  // Standard browser envs support document.cookie
  {
    write(e, t, n, r, o, i) {
      const s = [e + "=" + encodeURIComponent(t)];
      a.isNumber(n) && s.push("expires=" + new Date(n).toGMTString()), a.isString(r) && s.push("path=" + r), a.isString(o) && s.push("domain=" + o), i === !0 && s.push("secure"), document.cookie = s.join("; ");
    },
    read(e) {
      const t = document.cookie.match(new RegExp("(^|;\\s*)(" + e + ")=([^;]*)"));
      return t ? decodeURIComponent(t[3]) : null;
    },
    remove(e) {
      this.write(e, "", Date.now() - 864e5);
    }
  }
) : (
  // Non-standard browser env (web workers, react-native) lack needed support.
  {
    write() {
    },
    read() {
      return null;
    },
    remove() {
    }
  }
);
function Bn(e) {
  return /^([a-z][a-z\d+\-.]*:)?\/\//i.test(e);
}
function Mn(e, t) {
  return t ? e.replace(/\/?\/$/, "") + "/" + t.replace(/^\/+/, "") : e;
}
function ct(e, t) {
  return e && !Bn(t) ? Mn(e, t) : t;
}
const ke = (e) => e instanceof g ? { ...e } : e;
function F(e, t) {
  t = t || {};
  const n = {};
  function r(u, c, p) {
    return a.isPlainObject(u) && a.isPlainObject(c) ? a.merge.call({ caseless: p }, u, c) : a.isPlainObject(c) ? a.merge({}, c) : a.isArray(c) ? c.slice() : c;
  }
  function o(u, c, p) {
    if (a.isUndefined(c)) {
      if (!a.isUndefined(u))
        return r(void 0, u, p);
    } else
      return r(u, c, p);
  }
  function i(u, c) {
    if (!a.isUndefined(c))
      return r(void 0, c);
  }
  function s(u, c) {
    if (a.isUndefined(c)) {
      if (!a.isUndefined(u))
        return r(void 0, u);
    } else
      return r(void 0, c);
  }
  function l(u, c, p) {
    if (p in t)
      return r(u, c);
    if (p in e)
      return r(void 0, u);
  }
  const f = {
    url: i,
    method: i,
    data: i,
    baseURL: s,
    transformRequest: s,
    transformResponse: s,
    paramsSerializer: s,
    timeout: s,
    timeoutMessage: s,
    withCredentials: s,
    withXSRFToken: s,
    adapter: s,
    responseType: s,
    xsrfCookieName: s,
    xsrfHeaderName: s,
    onUploadProgress: s,
    onDownloadProgress: s,
    decompress: s,
    maxContentLength: s,
    maxBodyLength: s,
    beforeRedirect: s,
    transport: s,
    httpAgent: s,
    httpsAgent: s,
    cancelToken: s,
    socketPath: s,
    responseEncoding: s,
    validateStatus: l,
    headers: (u, c) => o(ke(u), ke(c), !0)
  };
  return a.forEach(Object.keys(Object.assign({}, e, t)), function(c) {
    const p = f[c] || o, _ = p(e[c], t[c], c);
    a.isUndefined(_) && p !== l || (n[c] = _);
  }), n;
}
const lt = (e) => {
  const t = F({}, e);
  let { data: n, withXSRFToken: r, xsrfHeaderName: o, xsrfCookieName: i, headers: s, auth: l } = t;
  t.headers = s = g.from(s), t.url = rt(ct(t.baseURL, t.url), e.params, e.paramsSerializer), l && s.set(
    "Authorization",
    "Basic " + btoa((l.username || "") + ":" + (l.password ? unescape(encodeURIComponent(l.password)) : ""))
  );
  let f;
  if (a.isFormData(n)) {
    if (w.hasStandardBrowserEnv || w.hasStandardBrowserWebWorkerEnv)
      s.setContentType(void 0);
    else if ((f = s.getContentType()) !== !1) {
      const [u, ...c] = f ? f.split(";").map((p) => p.trim()).filter(Boolean) : [];
      s.setContentType([u || "multipart/form-data", ...c].join("; "));
    }
  }
  if (w.hasStandardBrowserEnv && (r && a.isFunction(r) && (r = r(t)), r || r !== !1 && Fn(t.url))) {
    const u = o && i && kn.read(i);
    u && s.set(o, u);
  }
  return t;
}, vn = typeof XMLHttpRequest < "u", Hn = vn && function(e) {
  return new Promise(function(n, r) {
    const o = lt(e);
    let i = o.data;
    const s = g.from(o.headers).normalize();
    let { responseType: l } = o, f;
    function u() {
      o.cancelToken && o.cancelToken.unsubscribe(f), o.signal && o.signal.removeEventListener("abort", f);
    }
    let c = new XMLHttpRequest();
    c.open(o.method.toUpperCase(), o.url, !0), c.timeout = o.timeout;
    function p() {
      if (!c)
        return;
      const m = g.from(
        "getAllResponseHeaders" in c && c.getAllResponseHeaders()
      ), h = {
        data: !l || l === "text" || l === "json" ? c.responseText : c.response,
        status: c.status,
        statusText: c.statusText,
        headers: m,
        config: e,
        request: c
      };
      at(function(y) {
        n(y), u();
      }, function(y) {
        r(y), u();
      }, h), c = null;
    }
    "onloadend" in c ? c.onloadend = p : c.onreadystatechange = function() {
      !c || c.readyState !== 4 || c.status === 0 && !(c.responseURL && c.responseURL.indexOf("file:") === 0) || setTimeout(p);
    }, c.onabort = function() {
      c && (r(new E("Request aborted", E.ECONNABORTED, o, c)), c = null);
    }, c.onerror = function() {
      r(new E("Network Error", E.ERR_NETWORK, o, c)), c = null;
    }, c.ontimeout = function() {
      let d = o.timeout ? "timeout of " + o.timeout + "ms exceeded" : "timeout exceeded";
      const h = o.transitional || ot;
      o.timeoutErrorMessage && (d = o.timeoutErrorMessage), r(new E(
        d,
        h.clarifyTimeoutError ? E.ETIMEDOUT : E.ECONNABORTED,
        o,
        c
      )), c = null;
    }, i === void 0 && s.setContentType(null), "setRequestHeader" in c && a.forEach(s.toJSON(), function(d, h) {
      c.setRequestHeader(h, d);
    }), a.isUndefined(o.withCredentials) || (c.withCredentials = !!o.withCredentials), l && l !== "json" && (c.responseType = o.responseType), typeof o.onDownloadProgress == "function" && c.addEventListener("progress", X(o.onDownloadProgress, !0)), typeof o.onUploadProgress == "function" && c.upload && c.upload.addEventListener("progress", X(o.onUploadProgress)), (o.cancelToken || o.signal) && (f = (m) => {
      c && (r(!m || m.type ? new q(null, e, c) : m), c.abort(), c = null);
    }, o.cancelToken && o.cancelToken.subscribe(f), o.signal && (o.signal.aborted ? f() : o.signal.addEventListener("abort", f)));
    const _ = Un(o.url);
    if (_ && w.protocols.indexOf(_) === -1) {
      r(new E("Unsupported protocol " + _ + ":", E.ERR_BAD_REQUEST, e));
      return;
    }
    c.send(i || null);
  });
}, Cn = (e, t) => {
  let n = new AbortController(), r;
  const o = function(f) {
    if (!r) {
      r = !0, s();
      const u = f instanceof Error ? f : this.reason;
      n.abort(u instanceof E ? u : new q(u instanceof Error ? u.message : u));
    }
  };
  let i = t && setTimeout(() => {
    o(new E(`timeout ${t} of ms exceeded`, E.ETIMEDOUT));
  }, t);
  const s = () => {
    e && (i && clearTimeout(i), i = null, e.forEach((f) => {
      f && (f.removeEventListener ? f.removeEventListener("abort", o) : f.unsubscribe(o));
    }), e = null);
  };
  e.forEach((f) => f && f.addEventListener && f.addEventListener("abort", o));
  const { signal: l } = n;
  return l.unsubscribe = s, [l, () => {
    i && clearTimeout(i), i = null;
  }];
}, jn = Cn, qn = function* (e, t) {
  let n = e.byteLength;
  if (!t || n < t) {
    yield e;
    return;
  }
  let r = 0, o;
  for (; r < n; )
    o = r + t, yield e.slice(r, o), r = o;
}, Vn = new TextEncoder(), $n = async function* (e, t) {
  for await (const n of e)
    yield* qn(ArrayBuffer.isView(n) ? n : await Vn.encode(String(n)), t);
}, Be = (e, t, n, r) => {
  const o = $n(e, t);
  let i = 0;
  return new ReadableStream({
    type: "bytes",
    async pull(s) {
      const { done: l, value: f } = await o.next();
      if (l) {
        s.close(), r();
        return;
      }
      let u = f.byteLength;
      n && n(i += u), s.enqueue(new Uint8Array(f));
    },
    cancel(s) {
      return r(s), o.return();
    }
  }, {
    highWaterMark: 2
  });
}, Me = (e, t) => {
  const n = e != null;
  return (r) => setTimeout(() => t({
    lengthComputable: n,
    total: e,
    loaded: r
  }));
}, Ne = typeof fetch < "u", ut = Ne && typeof ReadableStream < "u", zn = ut && (() => {
  let e = !1;
  const t = new Request(w.origin, {
    body: new ReadableStream(),
    method: "POST",
    get duplex() {
      return e = !0, "half";
    }
  }).headers.has("Content-Type");
  return e && !t;
})(), ve = 64 * 1024, he = ut && !!(() => {
  try {
    return a.isReadableStream(new Response("").body);
  } catch {
  }
})(), Z = {
  stream: he && ((e) => e.body)
};
Ne && ((e) => {
  ["text", "arrayBuffer", "blob", "formData", "stream"].forEach((t) => {
    !Z[t] && (Z[t] = a.isFunction(e[t]) ? (n) => n[t]() : (n, r) => {
      throw new E(`Response type '${t}' is not supported`, E.ERR_NOT_SUPPORT, r);
    });
  });
})(new Response());
const Gn = async (e) => {
  if (e == null)
    return 0;
  if (a.isBlob(e))
    return e.size;
  if (a.isSpecCompliantForm(e))
    return (await new Request(e).arrayBuffer()).byteLength;
  if (a.isArrayBufferView(e))
    return e.byteLength;
  if (a.isURLSearchParams(e) && (e = e + ""), a.isString(e))
    return (await new TextEncoder().encode(e)).byteLength;
}, Qn = async (e, t) => {
  const n = a.toFiniteNumber(e.getContentLength());
  return n ?? Gn(t);
}, Wn = Ne && (async (e) => {
  let {
    url: t,
    method: n,
    data: r,
    signal: o,
    cancelToken: i,
    timeout: s,
    onDownloadProgress: l,
    onUploadProgress: f,
    responseType: u,
    headers: c,
    withCredentials: p = "same-origin",
    fetchOptions: _
  } = lt(e);
  u = u ? (u + "").toLowerCase() : "text";
  let [m, d] = o || i || s ? jn([o, i], s) : [], h, O;
  const y = () => {
    !h && setTimeout(() => {
      m && m.unsubscribe();
    }), h = !0;
  };
  let S;
  try {
    if (f && zn && n !== "get" && n !== "head" && (S = await Qn(c, r)) !== 0) {
      let L = new Request(t, {
        method: "POST",
        body: r,
        duplex: "half"
      }), k;
      a.isFormData(r) && (k = L.headers.get("content-type")) && c.setContentType(k), L.body && (r = Be(L.body, ve, Me(
        S,
        X(f)
      )));
    }
    a.isString(p) || (p = p ? "cors" : "omit"), O = new Request(t, {
      ..._,
      signal: m,
      method: n.toUpperCase(),
      headers: c.normalize().toJSON(),
      body: r,
      duplex: "half",
      withCredentials: p
    });
    let R = await fetch(O);
    const V = he && (u === "stream" || u === "response");
    if (he && (l || V)) {
      const L = {};
      ["status", "statusText", "headers"].forEach((Ie) => {
        L[Ie] = R[Ie];
      });
      const k = a.toFiniteNumber(R.headers.get("content-length"));
      R = new Response(
        Be(R.body, ve, l && Me(
          k,
          X(l, !0)
        ), V && y),
        L
      );
    }
    u = u || "text";
    let mt = await Z[a.findKey(Z, u) || "text"](R, e);
    return !V && y(), d && d(), await new Promise((L, k) => {
      at(L, k, {
        data: mt,
        headers: g.from(R.headers),
        status: R.status,
        statusText: R.statusText,
        config: e,
        request: O
      });
    });
  } catch (R) {
    throw y(), R && R.name === "TypeError" && /fetch/i.test(R.message) ? Object.assign(
      new E("Network Error", E.ERR_NETWORK, e, O),
      {
        cause: R.cause || R
      }
    ) : E.from(R, R && R.code, e, O);
  }
}), me = {
  http: cn,
  xhr: Hn,
  fetch: Wn
};
a.forEach(me, (e, t) => {
  if (e) {
    try {
      Object.defineProperty(e, "name", { value: t });
    } catch {
    }
    Object.defineProperty(e, "adapterName", { value: t });
  }
});
const He = (e) => `- ${e}`, Jn = (e) => a.isFunction(e) || e === null || e === !1, ft = {
  getAdapter: (e) => {
    e = a.isArray(e) ? e : [e];
    const { length: t } = e;
    let n, r;
    const o = {};
    for (let i = 0; i < t; i++) {
      n = e[i];
      let s;
      if (r = n, !Jn(n) && (r = me[(s = String(n)).toLowerCase()], r === void 0))
        throw new E(`Unknown adapter '${s}'`);
      if (r)
        break;
      o[s || "#" + i] = r;
    }
    if (!r) {
      const i = Object.entries(o).map(
        ([l, f]) => `adapter ${l} ` + (f === !1 ? "is not supported by the environment" : "is not available in the build")
      );
      let s = t ? i.length > 1 ? `since :
` + i.map(He).join(`
`) : " " + He(i[0]) : "as no adapter specified";
      throw new E(
        "There is no suitable adapter to dispatch the request " + s,
        "ERR_NOT_SUPPORT"
      );
    }
    return r;
  },
  adapters: me
};
function fe(e) {
  if (e.cancelToken && e.cancelToken.throwIfRequested(), e.signal && e.signal.aborted)
    throw new q(null, e);
}
function Ce(e) {
  return fe(e), e.headers = g.from(e.headers), e.data = ue.call(
    e,
    e.transformRequest
  ), ["post", "put", "patch"].indexOf(e.method) !== -1 && e.headers.setContentType("application/x-www-form-urlencoded", !1), ft.getAdapter(e.adapter || be.adapter)(e).then(function(r) {
    return fe(e), r.data = ue.call(
      e,
      e.transformResponse,
      r
    ), r.headers = g.from(r.headers), r;
  }, function(r) {
    return it(r) || (fe(e), r && r.response && (r.response.data = ue.call(
      e,
      e.transformResponse,
      r.response
    ), r.response.headers = g.from(r.response.headers))), Promise.reject(r);
  });
}
const pt = "1.7.0", we = {};
["object", "boolean", "number", "function", "string", "symbol"].forEach((e, t) => {
  we[e] = function(r) {
    return typeof r === e || "a" + (t < 1 ? "n " : " ") + e;
  };
});
const je = {};
we.transitional = function(t, n, r) {
  function o(i, s) {
    return "[Axios v" + pt + "] Transitional option '" + i + "'" + s + (r ? ". " + r : "");
  }
  return (i, s, l) => {
    if (t === !1)
      throw new E(
        o(s, " has been removed" + (n ? " in " + n : "")),
        E.ERR_DEPRECATED
      );
    return n && !je[s] && (je[s] = !0, console.warn(
      o(
        s,
        " has been deprecated since v" + n + " and will be removed in the near future"
      )
    )), t ? t(i, s, l) : !0;
  };
};
function Kn(e, t, n) {
  if (typeof e != "object")
    throw new E("options must be an object", E.ERR_BAD_OPTION_VALUE);
  const r = Object.keys(e);
  let o = r.length;
  for (; o-- > 0; ) {
    const i = r[o], s = t[i];
    if (s) {
      const l = e[i], f = l === void 0 || s(l, i, e);
      if (f !== !0)
        throw new E("option " + i + " must be " + f, E.ERR_BAD_OPTION_VALUE);
      continue;
    }
    if (n !== !0)
      throw new E("Unknown option " + i, E.ERR_BAD_OPTION);
  }
}
const _e = {
  assertOptions: Kn,
  validators: we
}, x = _e.validators;
class ee {
  constructor(t) {
    this.defaults = t, this.interceptors = {
      request: new xe(),
      response: new xe()
    };
  }
  /**
   * Dispatch a request
   *
   * @param {String|Object} configOrUrl The config specific for this request (merged with this.defaults)
   * @param {?Object} config
   *
   * @returns {Promise} The Promise to be fulfilled
   */
  async request(t, n) {
    try {
      return await this._request(t, n);
    } catch (r) {
      if (r instanceof Error) {
        let o;
        Error.captureStackTrace ? Error.captureStackTrace(o = {}) : o = new Error();
        const i = o.stack ? o.stack.replace(/^.+\n/, "") : "";
        try {
          r.stack ? i && !String(r.stack).endsWith(i.replace(/^.+\n.+\n/, "")) && (r.stack += `
` + i) : r.stack = i;
        } catch {
        }
      }
      throw r;
    }
  }
  _request(t, n) {
    typeof t == "string" ? (n = n || {}, n.url = t) : n = t || {}, n = F(this.defaults, n);
    const { transitional: r, paramsSerializer: o, headers: i } = n;
    r !== void 0 && _e.assertOptions(r, {
      silentJSONParsing: x.transitional(x.boolean),
      forcedJSONParsing: x.transitional(x.boolean),
      clarifyTimeoutError: x.transitional(x.boolean)
    }, !1), o != null && (a.isFunction(o) ? n.paramsSerializer = {
      serialize: o
    } : _e.assertOptions(o, {
      encode: x.function,
      serialize: x.function
    }, !0)), n.method = (n.method || this.defaults.method || "get").toLowerCase();
    let s = i && a.merge(
      i.common,
      i[n.method]
    );
    i && a.forEach(
      ["delete", "get", "head", "post", "put", "patch", "common"],
      (d) => {
        delete i[d];
      }
    ), n.headers = g.concat(s, i);
    const l = [];
    let f = !0;
    this.interceptors.request.forEach(function(h) {
      typeof h.runWhen == "function" && h.runWhen(n) === !1 || (f = f && h.synchronous, l.unshift(h.fulfilled, h.rejected));
    });
    const u = [];
    this.interceptors.response.forEach(function(h) {
      u.push(h.fulfilled, h.rejected);
    });
    let c, p = 0, _;
    if (!f) {
      const d = [Ce.bind(this), void 0];
      for (d.unshift.apply(d, l), d.push.apply(d, u), _ = d.length, c = Promise.resolve(n); p < _; )
        c = c.then(d[p++], d[p++]);
      return c;
    }
    _ = l.length;
    let m = n;
    for (p = 0; p < _; ) {
      const d = l[p++], h = l[p++];
      try {
        m = d(m);
      } catch (O) {
        h.call(this, O);
        break;
      }
    }
    try {
      c = Ce.call(this, m);
    } catch (d) {
      return Promise.reject(d);
    }
    for (p = 0, _ = u.length; p < _; )
      c = c.then(u[p++], u[p++]);
    return c;
  }
  getUri(t) {
    t = F(this.defaults, t);
    const n = ct(t.baseURL, t.url);
    return rt(n, t.params, t.paramsSerializer);
  }
}
a.forEach(["delete", "get", "head", "options"], function(t) {
  ee.prototype[t] = function(n, r) {
    return this.request(F(r || {}, {
      method: t,
      url: n,
      data: (r || {}).data
    }));
  };
});
a.forEach(["post", "put", "patch"], function(t) {
  function n(r) {
    return function(i, s, l) {
      return this.request(F(l || {}, {
        method: t,
        headers: r ? {
          "Content-Type": "multipart/form-data"
        } : {},
        url: i,
        data: s
      }));
    };
  }
  ee.prototype[t] = n(), ee.prototype[t + "Form"] = n(!0);
});
const Y = ee;
class ge {
  constructor(t) {
    if (typeof t != "function")
      throw new TypeError("executor must be a function.");
    let n;
    this.promise = new Promise(function(i) {
      n = i;
    });
    const r = this;
    this.promise.then((o) => {
      if (!r._listeners)
        return;
      let i = r._listeners.length;
      for (; i-- > 0; )
        r._listeners[i](o);
      r._listeners = null;
    }), this.promise.then = (o) => {
      let i;
      const s = new Promise((l) => {
        r.subscribe(l), i = l;
      }).then(o);
      return s.cancel = function() {
        r.unsubscribe(i);
      }, s;
    }, t(function(i, s, l) {
      r.reason || (r.reason = new q(i, s, l), n(r.reason));
    });
  }
  /**
   * Throws a `CanceledError` if cancellation has been requested.
   */
  throwIfRequested() {
    if (this.reason)
      throw this.reason;
  }
  /**
   * Subscribe to the cancel signal
   */
  subscribe(t) {
    if (this.reason) {
      t(this.reason);
      return;
    }
    this._listeners ? this._listeners.push(t) : this._listeners = [t];
  }
  /**
   * Unsubscribe from the cancel signal
   */
  unsubscribe(t) {
    if (!this._listeners)
      return;
    const n = this._listeners.indexOf(t);
    n !== -1 && this._listeners.splice(n, 1);
  }
  /**
   * Returns an object that contains a new `CancelToken` and a function that, when called,
   * cancels the `CancelToken`.
   */
  static source() {
    let t;
    return {
      token: new ge(function(o) {
        t = o;
      }),
      cancel: t
    };
  }
}
const Yn = ge;
function Xn(e) {
  return function(n) {
    return e.apply(null, n);
  };
}
function Zn(e) {
  return a.isObject(e) && e.isAxiosError === !0;
}
const Re = {
  Continue: 100,
  SwitchingProtocols: 101,
  Processing: 102,
  EarlyHints: 103,
  Ok: 200,
  Created: 201,
  Accepted: 202,
  NonAuthoritativeInformation: 203,
  NoContent: 204,
  ResetContent: 205,
  PartialContent: 206,
  MultiStatus: 207,
  AlreadyReported: 208,
  ImUsed: 226,
  MultipleChoices: 300,
  MovedPermanently: 301,
  Found: 302,
  SeeOther: 303,
  NotModified: 304,
  UseProxy: 305,
  Unused: 306,
  TemporaryRedirect: 307,
  PermanentRedirect: 308,
  BadRequest: 400,
  Unauthorized: 401,
  PaymentRequired: 402,
  Forbidden: 403,
  NotFound: 404,
  MethodNotAllowed: 405,
  NotAcceptable: 406,
  ProxyAuthenticationRequired: 407,
  RequestTimeout: 408,
  Conflict: 409,
  Gone: 410,
  LengthRequired: 411,
  PreconditionFailed: 412,
  PayloadTooLarge: 413,
  UriTooLong: 414,
  UnsupportedMediaType: 415,
  RangeNotSatisfiable: 416,
  ExpectationFailed: 417,
  ImATeapot: 418,
  MisdirectedRequest: 421,
  UnprocessableEntity: 422,
  Locked: 423,
  FailedDependency: 424,
  TooEarly: 425,
  UpgradeRequired: 426,
  PreconditionRequired: 428,
  TooManyRequests: 429,
  RequestHeaderFieldsTooLarge: 431,
  UnavailableForLegalReasons: 451,
  InternalServerError: 500,
  NotImplemented: 501,
  BadGateway: 502,
  ServiceUnavailable: 503,
  GatewayTimeout: 504,
  HttpVersionNotSupported: 505,
  VariantAlsoNegotiates: 506,
  InsufficientStorage: 507,
  LoopDetected: 508,
  NotExtended: 510,
  NetworkAuthenticationRequired: 511
};
Object.entries(Re).forEach(([e, t]) => {
  Re[t] = e;
});
const er = Re;
function dt(e) {
  const t = new Y(e), n = ze(Y.prototype.request, t);
  return a.extend(n, Y.prototype, t, { allOwnKeys: !0 }), a.extend(n, t, null, { allOwnKeys: !0 }), n.create = function(o) {
    return dt(F(e, o));
  }, n;
}
const T = dt(be);
T.Axios = Y;
T.CanceledError = q;
T.CancelToken = Yn;
T.isCancel = it;
T.VERSION = pt;
T.toFormData = se;
T.AxiosError = E;
T.Cancel = T.CanceledError;
T.all = function(t) {
  return Promise.all(t);
};
T.spread = Xn;
T.isAxiosError = Zn;
T.mergeConfig = F;
T.AxiosHeaders = g;
T.formToJSON = (e) => st(a.isHTMLForm(e) ? new FormData(e) : e);
T.getAdapter = ft.getAdapter;
T.HttpStatusCode = er;
T.default = T;
const tr = T;
var te;
(function(e) {
  e[e.CONTINUE = 100] = "CONTINUE", e[e.SWITCHING_PROTOCOLS = 101] = "SWITCHING_PROTOCOLS", e[e.PROCESSING = 102] = "PROCESSING", e[e.EARLY_HINTS = 103] = "EARLY_HINTS", e[e.OK = 200] = "OK", e[e.CREATED = 201] = "CREATED", e[e.ACCEPTED = 202] = "ACCEPTED", e[e.NON_AUTHORITATIVE_INFORMATION = 203] = "NON_AUTHORITATIVE_INFORMATION", e[e.NO_CONTENT = 204] = "NO_CONTENT", e[e.RESET_CONTENT = 205] = "RESET_CONTENT", e[e.PARTIAL_CONTENT = 206] = "PARTIAL_CONTENT", e[e.MULTI_STATUS = 207] = "MULTI_STATUS", e[e.MULTIPLE_CHOICES = 300] = "MULTIPLE_CHOICES", e[e.MOVED_PERMANENTLY = 301] = "MOVED_PERMANENTLY", e[e.MOVED_TEMPORARILY = 302] = "MOVED_TEMPORARILY", e[e.SEE_OTHER = 303] = "SEE_OTHER", e[e.NOT_MODIFIED = 304] = "NOT_MODIFIED", e[e.USE_PROXY = 305] = "USE_PROXY", e[e.TEMPORARY_REDIRECT = 307] = "TEMPORARY_REDIRECT", e[e.PERMANENT_REDIRECT = 308] = "PERMANENT_REDIRECT", e[e.BAD_REQUEST = 400] = "BAD_REQUEST", e[e.UNAUTHORIZED = 401] = "UNAUTHORIZED", e[e.PAYMENT_REQUIRED = 402] = "PAYMENT_REQUIRED", e[e.FORBIDDEN = 403] = "FORBIDDEN", e[e.NOT_FOUND = 404] = "NOT_FOUND", e[e.METHOD_NOT_ALLOWED = 405] = "METHOD_NOT_ALLOWED", e[e.NOT_ACCEPTABLE = 406] = "NOT_ACCEPTABLE", e[e.PROXY_AUTHENTICATION_REQUIRED = 407] = "PROXY_AUTHENTICATION_REQUIRED", e[e.REQUEST_TIMEOUT = 408] = "REQUEST_TIMEOUT", e[e.CONFLICT = 409] = "CONFLICT", e[e.GONE = 410] = "GONE", e[e.LENGTH_REQUIRED = 411] = "LENGTH_REQUIRED", e[e.PRECONDITION_FAILED = 412] = "PRECONDITION_FAILED", e[e.REQUEST_TOO_LONG = 413] = "REQUEST_TOO_LONG", e[e.REQUEST_URI_TOO_LONG = 414] = "REQUEST_URI_TOO_LONG", e[e.UNSUPPORTED_MEDIA_TYPE = 415] = "UNSUPPORTED_MEDIA_TYPE", e[e.REQUESTED_RANGE_NOT_SATISFIABLE = 416] = "REQUESTED_RANGE_NOT_SATISFIABLE", e[e.EXPECTATION_FAILED = 417] = "EXPECTATION_FAILED", e[e.IM_A_TEAPOT = 418] = "IM_A_TEAPOT", e[e.INSUFFICIENT_SPACE_ON_RESOURCE = 419] = "INSUFFICIENT_SPACE_ON_RESOURCE", e[e.METHOD_FAILURE = 420] = "METHOD_FAILURE", e[e.MISDIRECTED_REQUEST = 421] = "MISDIRECTED_REQUEST", e[e.UNPROCESSABLE_ENTITY = 422] = "UNPROCESSABLE_ENTITY", e[e.LOCKED = 423] = "LOCKED", e[e.FAILED_DEPENDENCY = 424] = "FAILED_DEPENDENCY", e[e.UPGRADE_REQUIRED = 426] = "UPGRADE_REQUIRED", e[e.PRECONDITION_REQUIRED = 428] = "PRECONDITION_REQUIRED", e[e.TOO_MANY_REQUESTS = 429] = "TOO_MANY_REQUESTS", e[e.REQUEST_HEADER_FIELDS_TOO_LARGE = 431] = "REQUEST_HEADER_FIELDS_TOO_LARGE", e[e.UNAVAILABLE_FOR_LEGAL_REASONS = 451] = "UNAVAILABLE_FOR_LEGAL_REASONS", e[e.INTERNAL_SERVER_ERROR = 500] = "INTERNAL_SERVER_ERROR", e[e.NOT_IMPLEMENTED = 501] = "NOT_IMPLEMENTED", e[e.BAD_GATEWAY = 502] = "BAD_GATEWAY", e[e.SERVICE_UNAVAILABLE = 503] = "SERVICE_UNAVAILABLE", e[e.GATEWAY_TIMEOUT = 504] = "GATEWAY_TIMEOUT", e[e.HTTP_VERSION_NOT_SUPPORTED = 505] = "HTTP_VERSION_NOT_SUPPORTED", e[e.INSUFFICIENT_STORAGE = 507] = "INSUFFICIENT_STORAGE", e[e.NETWORK_AUTHENTICATION_REQUIRED = 511] = "NETWORK_AUTHENTICATION_REQUIRED";
})(te || (te = {}));
const qe = tr.create({
  baseURL: "https://my.api.mockaroo.com/borg_/"
});
class nr {
  async getFeedback() {
    const t = await qe.get("_feedback.json?key=67b566e0");
    return t.status === te.OK ? {
      isSuccess: !0,
      data: t.data
    } : {
      isSuccess: !1,
      message: "Could not fetch Feedback"
    };
  }
  async getResult() {
    const t = await qe.get("_feedback_/_poll_/_results.json?key=67b566e0");
    return t.status === te.OK ? {
      isSuccess: !0,
      data: t.data
    } : {
      isSuccess: !1,
      message: "Could not fetch Result"
    };
  }
}
const Et = new nr(), rr = { class: "mp-poll__options" }, or = { class: "mp-poll__wrap-text" }, sr = { class: "mp-poll__progress-bg" }, ir = /* @__PURE__ */ Ve({
  __name: "Results",
  props: {
    data: {}
  },
  setup(e) {
    const n = B(e.data);
    async function r() {
      const o = await Et.getResult();
      o.isSuccess && (n.value = o.data);
    }
    return _t(r), (o, i) => (A(), P(pe, null, [
      D(b(C), { type: "h5" }, {
        default: M(() => [
          v(H(n.value.content), 1)
        ]),
        _: 1
      }),
      U("ul", rr, [
        (A(!0), P(pe, null, $e(n.value.options, (s) => (A(), P("li", {
          key: s.id
        }, [
          U("div", or, [
            D(b(C), null, {
              default: M(() => [
                v(H(s.content), 1)
              ]),
              _: 2
            }, 1024),
            D(b(C), null, {
              default: M(() => [
                v(H(s.percentage) + "%", 1)
              ]),
              _: 2
            }, 1024)
          ]),
          U("div", sr, [
            U("div", {
              class: "mp-poll__progress-bar",
              style: Rt(`width: ${s.percentage}%`)
            }, null, 4)
          ])
        ]))), 128))
      ])
    ], 64));
  }
});
const ht = (e, t) => {
  const n = e.__vccOpts || e;
  for (const [r, o] of t)
    n[r] = o;
  return n;
}, ar = /* @__PURE__ */ ht(ir, [["__scopeId", "data-v-bc5ece32"]]), cr = {
  key: 0,
  id: "mp-poll",
  class: "mp-poll"
}, lr = { class: "mp-poll__header" }, ur = {
  key: 0,
  class: "mp-poll__body"
}, fr = {
  key: 1,
  class: "mp-poll__body"
}, pr = { class: "mp-poll__options" }, dr = {
  key: 2,
  class: "mp-poll__footer"
}, Er = {
  key: 3,
  class: "mp-poll__footer"
}, hr = ["href"], mr = /* @__PURE__ */ Ve({
  __name: "Poll",
  props: {
    initialIsOpen: { type: Boolean }
  },
  setup(e) {
    const t = e, n = B(), r = B(), o = B(t.initialIsOpen || !1), i = B(!1), s = B(!1), l = Tt(() => {
      var u;
      return ((u = n.value) == null ? void 0 : u.link) || "#";
    });
    async function f() {
      const u = await Et.getFeedback();
      u.isSuccess && (n.value = u.data);
    }
    return Ot(f), (u, c) => n.value ? (A(), P("div", cr, [
      U("div", {
        class: Pe({
          "mp-poll__box": !0,
          hide: !o.value,
          show: o.value
        })
      }, [
        U("div", lr, [
          D(b(C), {
            type: "h6",
            class: "mp-poll__title"
          }, {
            default: M(() => [
              v(H(n.value.title), 1)
            ]),
            _: 1
          })
        ]),
        i.value ? (A(), P("div", ur, [
          D(ar, { data: n.value }, null, 8, ["data"])
        ])) : (A(), P("div", fr, [
          D(b(C), { type: "h5" }, {
            default: M(() => [
              v(H(n.value.content), 1)
            ]),
            _: 1
          }),
          U("ul", pr, [
            (A(!0), P(pe, null, $e(n.value.options, (p) => (A(), P("li", {
              key: p.id
            }, [
              D(b(yt), {
                modelValue: r.value,
                "onUpdate:modelValue": c[0] || (c[0] = (_) => r.value = _),
                value: p,
                label: p.content
              }, null, 8, ["modelValue", "value", "label"])
            ]))), 128))
          ])
        ])),
        n.value.type === "poll" ? (A(), P("div", dr, [
          !i.value && !s.value ? (A(), ae(b(W), {
            key: 0,
            text: u.$t("mp_poll.send"),
            "is-full-width": "",
            onClick: c[1] || (c[1] = (p) => {
              i.value = !0, s.value = !0;
            })
          }, null, 8, ["text"])) : Q("", !0),
          !i.value && !s.value ? (A(), ae(b(W), {
            key: 1,
            text: u.$t("mp_poll.results"),
            variant: "ghost",
            "is-full-width": "",
            onClick: c[2] || (c[2] = (p) => i.value = !0)
          }, null, 8, ["text"])) : Q("", !0),
          i.value && !s.value ? (A(), ae(b(W), {
            key: 2,
            class: "mp-poll__return-btn",
            text: u.$t("mp_poll.back_to_survey"),
            variant: "ghost",
            "left-icon": "arrow_back",
            onClick: c[3] || (c[3] = (p) => i.value = !1)
          }, null, 8, ["text"])) : Q("", !0)
        ])) : (A(), P("div", Er, [
          U("a", {
            href: l.value,
            target: "_blank"
          }, [
            D(b(W), {
              "is-full-width": "",
              text: n.value.cta
            }, null, 8, ["text"])
          ], 8, hr)
        ]))
      ], 2),
      U("div", {
        class: Pe({
          "mp-poll__toggle": !0,
          "mp-poll__toggle--opened": o.value
        }),
        onClick: c[4] || (c[4] = (p) => o.value = !o.value)
      }, [
        D(b(C), {
          type: "h6",
          "no-margin": "",
          class: "mp-poll__toggle-text"
        }, {
          default: M(() => [
            v(H(u.$t("mp_poll.survey")), 1)
          ]),
          _: 1
        }),
        D(b(At), {
          class: "mp-poll__toggle-icon",
          icon: "chevron_down",
          size: "lg"
        })
      ], 2)
    ])) : Q("", !0);
  }
});
const yr = /* @__PURE__ */ ht(mr, [["__scopeId", "data-v-deb1eb19"]]), _r = {
  survey: "Anketa",
  send: "Pošalji",
  results: "Pogledaj rezultate",
  back_to_survey: "Povratak na anketu"
}, Ar = {
  mp_poll: _r
}, Rr = {
  survey: "Survey",
  send: "Send",
  results: "Results",
  back_to_survey: "Back to survey"
}, br = {
  mp_poll: Rr
};
export {
  yr as Poll,
  br as en,
  Ar as hr
};
